import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = axios.create({ baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api' });
API.interceptors.request.use(cfg => {
  try { const u = JSON.parse(localStorage.getItem('npd_user')); if (u?.token) cfg.headers.Authorization = 'Bearer ' + u.token; } catch {}
  return cfg;
});

const GROUPS = [
  { key: 'projects', label: 'Projects', icon: '📁' },
  { key: 'products', label: 'Products', icon: '🧪' },
  { key: 'specs', label: 'Spec Sheets', icon: '📋' },
  { key: 'flavors', label: 'Flavor Profiles', icon: '👅' },
];

export default function GlobalSearch({ onClose }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState(null);
  const [flat, setFlat] = useState([]);
  const [sel, setSel] = useState(0);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => { inputRef.current?.focus(); }, []);

  useEffect(() => {
    if (q.trim().length < 2) { setResults(null); setFlat([]); return; }
    const t = setTimeout(() => {
      API.get('/global-search', { params: { q } }).then(r => {
        setResults(r.data);
        const f = [];
        GROUPS.forEach(g => (r.data[g.key] || []).forEach(item => f.push({ group: g.key, item })));
        setFlat(f); setSel(0);
      }).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const go = (entry) => {
    if (!entry) return;
    const { group, item } = entry;
    onClose();
    if (group === 'projects') navigate('/projects/' + item.id);
    else if (group === 'products') navigate('/products/' + item.id);
    else if (group === 'specs') navigate('/specs', { state: { openSheetId: item.id } });
    else if (group === 'flavors') navigate('/flavor-lab', { state: { flavorItem: item.item_code } });
  };

  const onKey = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setSel(s => Math.min(s + 1, flat.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setSel(s => Math.max(s - 1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); go(flat[sel]); }
    else if (e.key === 'Escape') { onClose(); }
  };

  let idx = -1;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,10,25,0.45)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '12vh' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 620, maxWidth: '94%', background: 'var(--bg-card, #fff)', borderRadius: 14, boxShadow: '0 12px 48px rgba(0,0,0,0.35)', overflow: 'hidden' }}>
        <input ref={inputRef} value={q} onChange={e => setQ(e.target.value)} onKeyDown={onKey}
          placeholder="Search items, products, spec sheets, flavors...  (Esc to close)"
          style={{ width: '100%', border: 'none', outline: 'none', padding: '16px 20px', fontSize: 16, background: 'transparent', color: 'inherit', boxSizing: 'border-box' }} />
        {results && (
          <div style={{ maxHeight: '55vh', overflowY: 'auto', borderTop: '1px solid var(--border, #eee)' }}>
            {GROUPS.map(g => {
              const list = results[g.key] || [];
              if (!list.length) return null;
              return (
                <div key={g.key}>
                  <div style={{ padding: '8px 20px 4px', fontSize: 10, fontWeight: 800, letterSpacing: '0.08em', color: 'var(--text-muted, #888)', textTransform: 'uppercase' }}>{g.icon} {g.label}</div>
                  {list.map(item => {
                    idx += 1;
                    const i = idx;
                    const title = item.item_name || item.name || item.doc_number || item.item_code;
                    const sub = g.key === 'projects' ? (item.project_code + ' · ' + (item.status || ''))
                      : g.key === 'products' ? (item.product_code + (item.is_sfg ? ' · SFG' : ' · FG'))
                      : g.key === 'specs' ? ((item.product_name || '') + ' · ' + (item.brand || '') + ' · ' + (item.status || ''))
                      : item.item_code;
                    return (
                      <div key={g.key + i} onMouseEnter={() => setSel(i)} onClick={() => go({ group: g.key, item })}
                        style={{ padding: '8px 20px', cursor: 'pointer', background: sel === i ? 'var(--bg-hover, #f7eef5)' : 'transparent' }}>
                        <div style={{ fontSize: 14, fontWeight: 600 }}>{title}</div>
                        <div style={{ fontSize: 11, color: 'var(--text-muted, #888)' }}>{sub}</div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            {flat.length === 0 && <div style={{ padding: 20, fontSize: 13, color: 'var(--text-muted, #888)' }}>No results for "{q}"</div>}
          </div>
        )}
      </div>
    </div>
  );
}
